import React, { Component } from "react";
import { view } from "react-easy-state";
// import store from "./state.js";

import Dockable, { widget } from "./dockable";
import workspace from "./workspace.json";
import BrushControls from "./widgets/BrushControls";
import Document from "./widgets/Document";
import Palette from "./widgets/Palette";

class Test extends Component {
  render() {
    return <div>Value: {this.props.value}!</div>;
  }
}

class App extends Component {
  state = {
    panels: [],
    testState: 10
  };

  updatePanels = panels => {
    this.setState({ panels: panels });
  };

  testfunction = () => {
    console.log("HAHAHAHAH");
  };

  render() {
    return (
      <Dockable
        // props
        initialState={workspace}
        onUpdate={this.updatePanels}
      >
        <BrushControls />
        <Document title="Untitled Document" />
        <Palette />
        <Test
          minHeight={10}
          closeable
          actions={() => [
            {
              type: "enum",
              selected: 0,
              options: ["thing 1", "thing 2", "thing 3"],
              onChange: function(i) {}
            },
            {
              type: "actions",
              actions: {
                Add: () => {
                  this.setState({ testState: this.state.testState + 1 });
                },
                Subtract: () => {
                  this.setState({ testState: this.state.testState - 1 });
                }
              }
            }
          ]}
          title={"Testing"}
          value={this.state.testState}
        />
      </Dockable>
    );
  }
}

export default view(App);
